import CardWithButton from "@public/ui-toolkit/src/CardWithButton";
import { useState, useEffect } from "react";
import Select from "react-select";
import ReportTable from "../ReportTable";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import React from "react";
import { Row, Col } from "antd";
const RiskReportType = [
  {
    label: "Exposures",
    value: 0,
  },
  {
    label: "VAR",
    value: 4,
  },
  {
    label: "Historical Stress",
    value: 6,
  },
  {
    label: "Predictive Stress",
    value: 8,
  },
  {
    label: "Payoffs",
    value: 10,
  },
  {
    label: "Barra",
    value: 14,
  }

]

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    marginRight: "10px",
  }),
};

const FundRiskReport = ({ fund, fundId, onCreateAuditLogs, reportExtractData, handleReportChange, riskReportMonthList, pmLoading, portal = "Allocator" }) => {

  const [riskReportType, setRiskReportType] = useState(null);
  const [fileName, setFileName] = useState("");
  const [riskReportYear, setRiskReportYear] = useState(0);
  const [selectedMonthValue, setSelectedMonthValue] = useState([]);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [monthValue, setMonthValue] = useState(null);
  const [reportExport, setReportExport] = useState({});


  useEffect(() => {
    if (fund) {
      setReportExport(fund.extractedRiskReport);
      RiskReportTypeString(fund.riskReportType);
    }
    if (riskReportMonthList) {
      getDefaultDate();
    }
  }, [fund, riskReportMonthList])

  const isEmpty = (obj) => {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop))
        return false
    }
    return true
  }

  const RiskReportTypeString = (type) => {
    switch (type) {
      case 0:
        setRiskReportType("Exposures")
        break;
      case 4:
        setRiskReportType("VAR")
        break;
      case 6:
        setRiskReportType("Historical Stress")
        break;
      case 8:
        setRiskReportType("Predictive Stress")
        break;
      case 10:
        setRiskReportType("Payoffs")
        break;
      case 14:
        setRiskReportType("Barra")
        break;
      default:
        break;
    }
  }
  const handleReportsChange = (e, monthValues) => {
    let riskReportType = e.value;
    var reportType = "";
    switch (Number(riskReportType)) {
      case 0:
        reportType = "Exposures"
        break;
      case 4:
        reportType = "VAR";
        break;
      case 6:
        reportType = "Historical Stress";
        break;
      case 8:
        reportType = "Predictive Stress";
        break;
      case 10:
        reportType = "Payoffs";
        break;
      case 14:
        reportType = "Barra";
        break;
      default:
        break;
    }
    setRiskReportType({ value: riskReportType, label: reportType });
    const monthData = monthValues?.value;
    let month = moment().month(monthData ? monthData : monthValue.value).format("M");
    let currentMonth = moment(`${riskReportYear?.value}-${month}-01`).format('YYYY-MM-DD');
    setFileName(`${fund.name} | MSCI Risk Report | ${reportType} | ${monthData ? monthData : monthValue.value} ${riskReportYear?.value}`);
    if (portal === "Allocator") {
      const value = {
        actionName: "View Risk Report",
        parameters: { id: fundId, month: moment(currentMonth).format("MM-yyyy"), riskReportType: reportType }
      }
      onCreateAuditLogs(value);
    }
    handleReportChange({ id: fundId, month: currentMonth, riskReportType: riskReportType })
  };

  const generate = () => {
    let month = moment().month(monthValue.value).format("M");
    let currentMonth = moment(`${riskReportYear?.value}-${month}`).format('MM-YYYY');
    if (portal === "Allocator") {
      const values = {
        actionName: "Download Risk Report",
        parameters: { RiskReportType: riskReportType.label, month: currentMonth }
      }
      onCreateAuditLogs(values);
    }
    setDownloadLoading(true)
    const input = document.getElementById('riskReportPdf');

    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'px', 'a4', {
          orientation: 'portrait',
        });

        const imgProps = pdf.getImageProperties(imgData);
        var width = pdf.internal.pageSize.getWidth();
        var height = (imgProps.height * width) / imgProps.width;

        pdf.addImage(imgData, 'png', 0, 0, width, height);
        pdf.save("RiskReport.pdf");
        setDownloadLoading(false)
      });
  }
  const getDefaultDate = () => {
    if (fund?.latestRiskReport !== null) {
      const currentMonth = new Date(fund?.latestRiskReport);
      const month = currentMonth.toLocaleString('default', { month: 'long' });
      const year = { value: currentMonth.getFullYear(), label: currentMonth.getFullYear() };
      if (year.value > 0) {
        var selected = riskReportMonthList?.filter(
          (u) => u.year === year.value
        );
        if (selected?.length) {
          setSelectedMonthValue(year.value > 0 ? selected[0].month : []);
        }
      }
      setRiskReportYear(year.value > 0 ? year : "");
      setMonthValue(year.value > 0 ? { value: month, label: month } : "")
      setRiskReportType(year.value > 0 ? RiskReportType[5] : "");
      var reportValue = year.value > 0 ? `| ${RiskReportType[5].label} | ${`${month} ${year.value}`}` : "";
      setFileName(year.value > 0 ? `${fund?.name} | MSCI Risk Report ${reportValue}` : `${fund?.name} | MSCI Risk Report`);
    }
  }


  return (
    <Row className="component mt-3">
      <Col span={24} className="component-header">
        <Row style={{ padding: "10px" }}>
          <Col span={14} style={{ margin: "auto" }}>
            <div className="Fund-FontSize" style={{ fontSize : "26px" }}>MSCI Risk Reports</div>
          </Col>
          <Col span={10}>
            <Row style={{ justifyContent: "end" }}>
              <Select
                styles={customStyles}
                isDisabled={riskReportYear ? false : true}
                value={riskReportYear ? riskReportYear : { value: "Year", label: "Year" }}
                pmLoading={pmLoading}
                onChange={(monthObj) => {
                  var selected = riskReportMonthList?.filter(
                    (u) => u.year === monthObj.value
                  );
                  if (selected?.length) {
                    setRiskReportYear({ value: selected[0]?.year, label: selected[0]?.year });
                    setMonthValue(null);
                    setRiskReportType(null);
                    setSelectedMonthValue(selected[0]?.month);
                  }
                }}
                options={riskReportMonthList?.map(it => ({ value: it.year, label: it.year }))}
              />

              <Select
                styles={customStyles}
                isDisabled={riskReportYear ? false : true}
                value={monthValue ? monthValue : { value: "Month", label: "Month" }}
                pmLoading={pmLoading}
                onChange={(e) => {
                  setMonthValue({ value: e.value, label: e.value });
                  setRiskReportType(null);
                  handleReportsChange({ value: 14 }, { value: e.value, label: e.value });
                }
                }
                options={selectedMonthValue.map((it) =>  ({ value: it, label: it }))}
              />
              <Select
                styles={customStyles}
                isDisabled={riskReportYear ? false : true}
                placeholder={"Risk Report Type"}
                value={riskReportType}
                pmLoading={pmLoading}
                onChange={handleReportsChange}
                options={RiskReportType}
              />
            </Row>
          </Col>
        </Row>
      </Col>
      <Col span={24} className="component-body">
        <ReportTable reportExtractData={!isEmpty(reportExtractData) ? reportExtractData : reportExport}
          reportName={fileName} id="riskReportPdf" isEmpty={isEmpty} RiskReportType={RiskReportType}
          fundName={fund.name} downloadFile={generate} downloadLoading={downloadLoading} />
      </Col>
    </Row>
  )
};

export default FundRiskReport;
